import { render, staticRenderFns } from "./CustomerTrackingFreelanceGuide.vue?vue&type=template&id=5b4d53e7&scoped=true&"
import script from "./CustomerTrackingFreelanceGuide.vue?vue&type=script&lang=js&"
export * from "./CustomerTrackingFreelanceGuide.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTrackingFreelanceGuide.vue?vue&type=style&index=0&id=5b4d53e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4d53e7",
  null
  
)

export default component.exports